module.exports = __webpack_public_path__ + "assets/img/survey_1x.d8cb9156.png";